import { __assign } from '../node_modules/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import SvgIcon from '@mui/material/SvgIcon';

var CloseIcon = forwardRef(function (props, ref) {
    return (React.createElement(SvgIcon, __assign({}, props, { ref: ref }),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20.279", height: "20.21", viewBox: "0 0 20.279 20.21" },
            React.createElement("g", { "data-name": "cancel/close" },
                React.createElement("g", { "data-name": "Group 418" },
                    React.createElement("path", { "data-name": "Path 435", d: "m10.285 9.211 7.892-7.892a.767.767 0 1 0-1.065-1.1l-.019.019L9.2 8.127 1.308.234A.767.767 0 0 0 .224 1.319l7.893 7.892L.224 17.1a.767.767 0 1 0 1.084 1.084L9.2 10.3l7.892 7.892a.767.767 0 0 0 1.085-1.092z", transform: "translate(.948 .85)", stroke: "currentColor", fill: "currentColor", strokeWidth: "1.7px" }))))));
});

export { CloseIcon };
//# sourceMappingURL=CloseIcon.js.map
